import React from 'react';
import Section from './Section';

const ExperienceItem = ({ item }) => (
  <div className="timeline-item">
    <div className="timeline-dot" />
    <div className="timeline-content card glass">
      <div className="row space-between">
        <h3>{item.role} · <span className="accent">{item.company}</span></h3>
        <span className="muted small">{item.period}</span>
      </div>
      <ul className="bullets">
        {item.highlights.map((h, i) => <li key={i}>{h}</li>)}
      </ul>
      {item.tech?.length > 0 && (
        <ul className="tags">
          {item.tech.map((t) => <li key={t}>{t}</li>)}
        </ul>
      )}
    </div>
  </div>
);

const Experience = ({ items = [] }) => {
  return (
    <Section id="experience" title="Experience" subtitle="Where I've worked">
      <div className="timeline">
        {items.map((it) => <ExperienceItem key={it.id} item={it} />)}
      </div>
    </Section>
  );
};

export default Experience;
